import { useFormContext } from "react-hook-form";
import type { QuoteDetailDto } from "@/lib/quotes";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { QuoteHeroFormValues } from "./QuoteStatusTermsCard";

export interface QuoteRefDescCardProps {
  quote: QuoteDetailDto;
  /** When true (quote is Draft|Sent) the fields become editable inputs bound to the shared form. */
  editable?: boolean;
}

export function QuoteRefDescCard({ quote, editable = false }: QuoteRefDescCardProps) {
  const form = useFormContext<QuoteHeroFormValues>();

  // Read-only rendering when the quote is locked (or no form context is present).
  if (!editable || !form) {
    return (
      <Card className="border border-slate-400 rounded-xl bg-white shadow-sm">
        <CardContent className="space-y-4 p-4">
          <div className="flex items-center gap-4">
            <div className="text-sm font-bold text-[#1a2f4c] shrink-0 w-32">Customer Ref.:</div>
            <div className="text-sm text-slate-500 bg-[#f1f3f5] rounded-md px-3 py-2 flex-1 truncate">
              {quote.purchaseOrder || "—"}
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-sm font-bold text-[#1a2f4c] shrink-0 w-32">Quote Desc.:</div>
            <div className="text-sm text-slate-500 bg-[#f1f3f5] rounded-md px-3 py-2 flex-1 truncate">
              {quote.description || "—"}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border border-slate-400 rounded-xl bg-white shadow-sm">
      <CardContent className="space-y-4 p-4">
        <div className="flex items-center gap-4">
          <Label
            htmlFor="quote-customer-ref"
            className="text-sm font-bold text-[#1a2f4c] shrink-0 w-32"
          >
            Customer Ref.:
          </Label>
          <Input
            id="quote-customer-ref"
            className="flex-1"
            placeholder="Customer reference / PO"
            {...form.register("purchaseOrder")}
          />
        </div>
        <div className="flex items-start gap-4">
          <Label
            htmlFor="quote-description"
            className="text-sm font-bold text-[#1a2f4c] shrink-0 w-32 pt-2"
          >
            Quote Desc.:
          </Label>
          <Textarea
            id="quote-description"
            rows={2}
            className="flex-1"
            placeholder="Quote description"
            {...form.register("description")}
          />
        </div>
      </CardContent>
    </Card>
  );
}
